<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      :hide-overlay="!dialog"
      @keydown.esc="dialog = false"
      :fullscreen="is_mobile"
      :scrollable="false"
      width="500"
      overlay-opacity="50"
      overlay-color="#ffffff"
      content-class="default-dialog"
    >
      <template v-slot:activator="{}">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              @click.stop="dialog = true"
              icon
            >
              <v-icon>mdi-database-search</v-icon>
            </v-btn>
          </template>
          <span>{{ lang.global.filters }}</span>
        </v-tooltip>
        <v-divider
          inset
          vertical
        ></v-divider>
      </template>

      <v-card v-if="dialog">
        <v-card-title class="dialog-title">
          <span class="headline">
            <v-icon class="toolbar-icon">mdi-database-search</v-icon>
            {{ lang.global.filters }}
          </span>
          <v-spacer></v-spacer>
          <v-icon class="dialog-close-btn" @click="dialog = false">mdi-close</v-icon>
        </v-card-title>

        <v-card-text>
          <v-container
            v-bar="{ preventParentScroll: true, scrollThrottle: 30, resizeRefresh: true }"
            class="overflow-y-auto dialog-scrollbar"
            style="max-height: 350px; padding: 0px !important;"
          >
            <v-content class="filters-content">
              <v-row justify="center">
                <v-expansion-panels flat>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="justify-self-start" disable-icon-rotate>
                      <div>
                        <v-icon medium left>mdi-calendar</v-icon>
                        <span>{{ lang.historic.filters.date_range.title }}</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-daterange
                        v-model="filters.date"
                        :presets="presets"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="justify-self-start" disable-icon-rotate>
                      <div>
                        <v-icon medium left>mdi-format-list-text</v-icon>
                        <span>{{ lang.historic.filters.categories.title }}</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <treeselect
                        :options="categories"
                        v-model="filters.categories"
                        :multiple="true"
                        :placeholder="lang.users.datatable.headers.all_category"
                        :noChildrenText="lang.items.new.noChildrenText"
                        :noOptionsText="lang.items.new.noCategoriesText"
                        :noResultsText="lang.items.new.noResultsText"
                        :clearable="true"
                        :default-expand-level="1"
                        :zIndex="9999"
                        appendToBody
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="justify-self-start" disable-icon-rotate>
                      <div>
                        <v-icon medium left>mdi-currency-usd</v-icon>
                        <span>{{ lang.historic.filters.price_range.title }}</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-pricerange
                        v-model="filters.price"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="justify-self-start" disable-icon-rotate>
                      <div>
                        <v-icon medium left>mdi-state-machine</v-icon>
                        <span>{{ lang.historic.filters.status.title }}</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-select
                        v-model="filters.status"
                        :items="[{ id: 1, title: lang.items.status.inactive }, { id: 2, title: lang.items.status.active }]"
                        :label="lang.historic.filters.status.title"
                        :clearable="true"
                        item-text="title"
                        item-value="id"
                        clear-icon="mdi-broom"
                        single-line
                        chips
                        deletable-chips
                        filled
                        attach
                        hide-details
                      ></v-select>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-row>
            </v-content>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click.stop="reset()"
          >
            {{ lang.historic.filters.reset }}
          </v-btn>
          <v-btn
            color="green"
            text
            @click.stop="apply()"
          >
            {{ lang.historic.filters.apply }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import daterange from '@/components/utils/daterange/mixins'
import VPricerange from '@/components/utils/pricerange/VPricerange'
import Treeselect from '@riophae/vue-treeselect'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import defaults from '@/mixins/defaults/filters'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: { Treeselect, VPricerange },
  mixins: [ appdata, utils, daterange ],
  data () {
    return {
      dialog: false,
      filters: {}
    }
  },
  computed: {
    categories: function () {
      var itemsCat = Object.values(this.get_data.categories) || []
      var parents = itemsCat.filter(parent => parent.parent === 0) || []
      parents.forEach(function (val) {
        const childrens = itemsCat.filter(children => children.parent !== 0 && children.parent === val.id) || []
        childrens.forEach(function (childVal) {
          childVal.label = childVal.name
        })
        val.label = val.name
        val.children = (childrens.length > 0 ? childrens : [])
      })
      return parents
    }
  },
  watch: {
    dialog (val) {
      if (val) this.refresh()
    }
  },
  methods: {
    refresh () {
      const globalFilters = (this.get_global.filters.catalog && this.get_global.filters.catalog.data ? { ...this.get_global.filters.catalog.data } : { ...defaults.catalog.data })
      this.filters = { ...globalFilters }
    },
    reset () {
      this.filters = (defaults.catalog.data ? { ...defaults.catalog.data } : [])
    },
    apply () {
      const applyFilters = {
        catalog: {
          page: 2,
          data: { ...this.filters }
        }
      }
      this.$store.dispatch('setGlobalFilters', Object.assign({}, { ...applyFilters }))
      this.$store.dispatch('socket/CUSTOM_DATA', this.get_global.filters)
      this.dialog = false
    }
  },
  created () {
    this.refresh()
  }
}
</script>

<style scoped>
#app .v-dialog > .v-card > .v-card__text {
  padding: 0px 9px 0px 9px;
}
#app .filters-content {
  padding: 0px !important;
  height: auto !important;
}
</style>
